import { ChangeEvent } from 'react'
import styles from './DefaultNumberInput.module.css'

interface DefaultNumberInputProps {
  value: number | null
  onChange: (value: number | null) => void
  min?: number
  max?: number
  disabled?: boolean
  label?: string
  width?: number
}

export const DefaultNumberInput = ({
  value,
  onChange,
  min,
  max,
  disabled,
  label,
  width = 80,
}: DefaultNumberInputProps) => {
  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    onChange(e.target.valueAsNumber || null)
  }

  return (
    <>
      {label && <label className={styles.inputLabel}>{label}</label>}
      <input
        className={styles.defaultNumberInput}
        type="number"
        min={min}
        max={max}
        value={value === null ? '' : value}
        onChange={handleChange}
        disabled={disabled}
        style={{ width: width }}
      />
    </>
  )
}
